import { useState, useEffect } from "react";
import { v4 as uuid } from "uuid";
import { Field, FieldArray } from "formik";
import { EMPTY_STRING } from "../../../../constants";
import { redTrashIcon } from "../../../../assets/icons";

const BackgroundTaskInputs = ({
  name,
  label,
  handleChange,
  options = [],
  values,
}) => {
  const DEFAULT_VALUE = {
    id: uuid(),
    key: EMPTY_STRING,
    value: EMPTY_STRING,
  };
  const [formData, setFormData] = useState([]);
  const [fields, setFields] = useState([]);

  useEffect(() => {
    values && setFormData(values);
  }, [values]);

  useEffect(() => {
    setFields(options);
  }, [options]);

  const handleOnSelect = (id, e) => {
    const updatedFormData = formData.map((each) => {
      if (each.id === id) each = { ...each, key: e.target.value };
      return each;
    });
    setFormData(updatedFormData);
  };

  const handleOnInput = (key, e) => {
    const updatedFormData = formData.map((each) => {
      if (each.key === key) each = { ...each, value: e.target.value };
      return each;
    });
    setFormData(updatedFormData);
    handleChange(updatedFormData);
  };

  const handleAddField = () => setFormData((prev) => [...prev, DEFAULT_VALUE]);

  return (
    <FieldArray
      name={name}
      render={(arrayHelpers) => (
        <div className="form-group">
          <label className="text-sm font-medium text-gray-50 mb-1 block">
            {label}
          </label>
          {formData &&
            formData.map((each, index) => (
              <div className="flex flex-row items-center mb-1" key={each.id}>
                <Field
                  as="select"
                  name={`${name}_property`}
                  className="form-control"
                  value={each.key}
                  onChange={(e) => handleOnSelect(each.id, e)}
                >
                  {fields.map((field) => (
                    <option key={field.name} value={field.schema.key}>
                      {field.name}
                    </option>
                  ))}
                </Field>
                <span className="text-gray-50 p-2"> = </span>
                <Field
                  type="text"
                  name={`${name}_value`}
                  className="form-control p-2"
                  value={each.value}
                  placeholder="Value"
                  onChange={(e) => handleOnInput(each.key, e)}
                />
                <div className="w-20 h-5 m-3">
                  <button
                    className="hover:opacity-80 active:opacity-100"
                    type="button"
                    onClick={() => arrayHelpers.remove(index)}
                  >
                    <img src={redTrashIcon} alt="delete" />
                  </button>
                </div>
              </div>
            ))}
          <div className="form-group">
            <div className="text-sm font-medium text-gray-50 mb-1 flex flex-row form-control">
              <button
                type="button"
                className="rounded items-center w-full btn-primary-light"
                disabled={formData.length >= options.length}
                onClick={() => handleAddField()}
              >
                Add Value
              </button>
            </div>
          </div>
        </div>
      )}
    />
  );
};

export default BackgroundTaskInputs;
